import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["icon"]
  
  connect() {
    this.applyTheme(this.getPreferredTheme())
    window.matchMedia("(prefers-color-scheme: dark)")
      .addEventListener("change", this.handleSystemChange.bind(this))
  }
  
  toggle() {
    const isDark = document.documentElement.classList.contains("dark")
    const newTheme = isDark ? "light" : "dark"
    this.applyTheme(newTheme)
    localStorage.setItem("maq-theme", newTheme)
  }
  
  getPreferredTheme() {
    const stored = localStorage.getItem("maq-theme")
    if (stored) return stored
    return window.matchMedia("(prefers-color-scheme: dark)").matches ? "dark" : "light"
  }
  
  applyTheme(theme) {
    document.documentElement.classList.toggle("dark", theme === "dark")
  }
  
  handleSystemChange(e) {
    if (!localStorage.getItem("maq-theme")) {
      this.applyTheme(e.matches ? "dark" : "light")
    }
  }
}
